import { Injectable } from '@angular/core';
import * as $ from 'jquery';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccessibilityService {

  className: string = "";
  public resizeFont: BehaviorSubject<string> = new BehaviorSubject<string>(this.className);
  currentResizeFont = this.resizeFont.asObservable();

  constructor() { }

  addLoadingAttr(){
    setTimeout(() => {
      $(".lds-roller").attr("aria-live","polite");
    }, 100);
  }

  startloadingAccessibility(){
    setTimeout(() => {
      $(".hidden.spinner.center .lds-roller .dataloaded").remove();
      $(".visible.spinner.center .lds-roller").append("<span class='startloading' style='color: #000'>Start loading</span>");
    }, 100);
  }

  loadedAccessibility(){
    setTimeout(() => {
      $(".visible.spinner.center .lds-roller .startloading").remove();
      $(".hidden.spinner.center .lds-roller").append("<span class='dataloaded' style='color: #000'>Loading please wait</span>");
    }, 100);
  }

  resizeFontSize(className: string) {
    this.resizeFont.next(className);
  }
}
